<template>
	<div class="container">
		<span v-if="showDetails">
			<h2 class="text-white">{{ title }}</h2>
			<h4 class="text-white">{{ subtitle }}</h4>
			<p v-html="description" style="overflow-wrap: break-word"></p>
			<div v-if="description" class="button-container">
				<button class="copy-button" title="Hide Details" @click="showDetails = !showDetails">
					<i class="fas fa-info-circle mr-2" @click="showDetails = !showDetails"></i>
					Minimize
				</button>
				<button class="copy-button" title="Copy to Clipboard" @click="copyToClipboard">
					<i class="fas fa-copy" @click="copyToClipboard"></i>
					Copy to Clipboard
				</button>
			</div>
		</span>
		<div v-else class="d-flex align-items-center">
			<h4 class="text-white mb-0 pb-0">{{ title ? title : subtitle }}</h4>
			<div class="button-container">
				<i class="fas fa-info-circle ml-4 mr-2" title="Show Details" @click="showDetails = !showDetails"></i>

				<i class="fas fa-copy" title="Copy to Clipboard" @click="copyToClipboard"></i>
			</div>
		</div>
	</div>
</template>
<script>
import VueClipboard from "vue-clipboard2";
import Vue from "vue";

export default {
	name: "vue-toastr",
	props: {
		title: {
			type: String,
			description: "Notification",
		},
		subtitle: {
			type: String,
			description: "Sub Title",
		},
		description: null,
	},
	mounted() {
		Vue.use(VueClipboard);
	},
	data() {
		return {
			showDetails: true,
		};
	},
	methods: {
		copyToClipboard() {
			let copyText = `${this.title ? this.title : ""}\n${this.subtitle ? this.subtitle : ""}\n${
				typeof this.description === "object"
					? JSON.stringify(this.description)
					: this.description
					? this.extractTextFromHTML(this.description)
					: ""
			}`;

			this.$copyText(copyText)
				.then(() => {
					this.$toast.info("Message copied to clipboard");
				})
				.catch(() => {
					this.$toast.error("Failed to copy message");
				});
		},
		extractTextFromHTML(htmlString) {
			const tempElement = document.createElement("div");
			tempElement.innerHTML = htmlString;
			return tempElement.textContent || tempElement.innerText || "";
		},
	},
};
</script>

<style scoped>
.copy-button {
	background-color: transparent;
	color: white;
	border: 1px solid white;
	border-radius: 5px;
	padding: 5px 10px;
	cursor: pointer;
}

.copy-button:hover {
	background-color: rgba(255, 255, 255, 0.2);
}
.button-container {
	display: flex;
	justify-content: space-around;
	align-items: center;
}

.container {
	max-width: 480px;
	max-height: 500px;
	overflow: auto;
}
</style>
